'use client';

// SignalR tạm thời bị TẮT do đang bug — không khởi tạo kết nối nữa.
// import { useEmployeeInfoStore } from '@/hooks/use-employee-store';
// import { useAuthenticationStore } from '@/provider/customs/useAuthenticationStore';
// import { useSignalRCenter } from '@/signalR/use-signal-center';

/**Component sử dụng để connect với signalR */
export const SignalConnect = () => {
    // const authData = useAuthenticationStore((x) => x.auth);
    // const empInfo = useEmployeeInfoStore((x) => x.current);

    // resolver signalR
    // useSignalRCenter({
    //     accountId: authData?.UserId || authData?.CustomerId,
    //     accountRole: authData?.Roles,
    //     empId: empInfo?.ID,
    //     unitId: empInfo?.UnitId,
    //     token: authData?.SessionToken,
    // });

    return <></>;
};
